import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../Binding/binding.scss';
import SANScan from './SANScan';
import Button from "@material-ui/core/Button";
import CartonDisplay from '../Shipping/CartonDisplay';
import ErrorMessage from '../Shared/components/ErrorMessage';
import ShipmentsSrv from "../../services/shipments_srv";
import { SHIPPED } from "../Shared/constants/ShipmentStatus";

function getSteps() {
  return ['Scan Carrier SAN', 'Confirm Shipment'];
}

 const steps = getSteps();



function Shipping(props) {
  const shipmentsSrv = new ShipmentsSrv(props.auth);

    const [activeStep, setStep] = useState(0);
    const [ SAN, setSAN]= useState(null);
    const [ shipmentSAN, setShipmentSAN] = useState(null);
    const [SANMatchError, setSANMatchError] = useState('');
    const [cartons, setCartons] = useState(null);

    const reload=()=>{
      setStep(0);
      setSAN(null);
      setShipmentSAN(null);
      setSANMatchError('');
      setCartons(null);
    }

    useEffect(() => {
      setSANMatchError('');
      if(shipmentSAN  && shipmentSAN !== SAN){
        setSANMatchError('The SANs do NOT MATCH');
      }
    }, props.shipmentSAN);

    const displaySelectedStep = () => {
      if(activeStep === 0){
          return(<>
                    
                    <div className="field-text">
                        Please Scan the Carrier SAN:
                    </div>
        
                    <Col>
                    
                      <SANScan auth={props.auth} setSAN={setSAN}></SANScan>
                    </Col>
                    {SAN!== null?
                      <>
                      <Row>
                        <Col>
                            <div className='selected-SAN'>
                                Scanned Carrier SAN:
                                {SAN}
                            </div> 
                        </Col>
                        </Row>
                      
                        </>
                        :null
                    }
                      <Row>
                        <Col className='next-button'>
                            {SAN !== null ?
                              <Button className="step-next-button show" variant="contained" onClick={()=>setStep(1)}>Next</Button>
                              : <Button className="step-next-button " variant="contained" disabled> Next</Button>}
                        </Col>
                      </Row>
                </>
                   
                  )
      }if(activeStep === 1){
          return(<>
                    {SAN!== null?
                      <>
                      <Row>
                        <Col>
                            <div className='selected-SAN'>
                                Scanned Carrier SAN:
                                {SAN}
                            </div> 
                        </Col>
                        </Row>
                        </>
                        :null
                    }
                    <div className="field-text">
                        Please Scan the Shipment SAN:
                    </div>
                    <Row>
                      <Col>
                        <SANScan auth={props.auth} setSAN={setShipmentSAN}></SANScan>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <ErrorMessage show={SANMatchError !== ''?true:false} errorMessage={SANMatchError}></ErrorMessage>
                      </Col>
                    </Row>
                    {shipmentSAN!== null?
                      <>
                      <Row>
                        <Col>
                            <div className='selected-SAN'>
                                Scanned Shipment SAN:
                                {shipmentSAN}
                            </div> 
                        </Col>
                        </Row>
                        <Row>
                          <Col>
                            <CartonDisplay auth={props.auth} SAN={shipmentSAN} cartons={cartons} setCartons={setCartons}></CartonDisplay>
                          </Col>
                        </Row>
                        </>
                        :null
                    }
                    <Row>
                        <Col className='next-button'>
                        <Button className="step-next-button show" variant="contained" onClick={()=>setStep(0)}>Back</Button>
                            {shipmentSAN !== null && shipmentSAN === SAN ?
                              <Button className="step-next-button show" variant="contained" onClick={()=>shipCartons()}>Ship</Button>
                              : <Button className="step-next-button " variant="contained" disabled>Ship</Button>}
                        </Col>
                      </Row>
                  </>)
      }if(activeStep === 2){
          return(<>
                    <Col>Success!</Col>
                    <Row>
                          <Col>
                            <CartonDisplay auth={props.auth} SAN={shipmentSAN} cartons={cartons} setCartons={setCartons}></CartonDisplay>
                          </Col>
                        </Row>
                    <Row>
                        <Col className='next-button'>
                        <Button className="step-next-button show" variant="contained" onClick={()=>reload()}>Ship New</Button>
                        </Col>
                    </Row>
                  </>)
      }if(activeStep === 3){
        return(<>
                  <Col><ErrorMessage show={true} errorMessage={"Error: Failed to Set Shipments, please try again!"}></ErrorMessage></Col>
                  <Row>
                        <Col className='next-button'>
                        <Button className="step-next-button show" variant="contained" onClick={()=>reload()}>Retry</Button>
                        </Col>
                  </Row>
                </>)
      }
    }
    const shipCartons = ()  => {

      bulkUpdateShipment();

 }

    const  bulkUpdateShipment = () => {
      shipmentsSrv.updateShipmentBulk({ authorizationCode:shipmentSAN, status:SHIPPED})
              .then((res) => {
                  return res.json()
              }
          )
          .then((result) => {
              if (result) {
                setStep(2);
              }else{
                setStep(3);
              }
          }
          ).catch( (error) => { 
            console.log('error', error)  
                setStep(3);
                
          });
    }

 
    return <Container className='ship-container'>
      <Row>
          <Col className='header'> Shipping</Col>
      </Row>
       <Stepper activeStep={activeStep}>
       {steps.map((label) => {
              const stepProps = {};
              const labelProps = {};
              return (
                      <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps}>{label}</StepLabel>
                      </Step>
                  );
              })}
       </Stepper>
       {displaySelectedStep()}
    </Container>
    ;
  }




  export default Shipping;